const replaceHost = {
    'fintech-loan-marketing.didiglobal.com': 'loan-marketing.didifinance.com',
};

export const clusterReplaceUrl = (url: string) => {
    if (/didifinance\.com/.test(window.location.host)) {
        let replacedUrl = url;

        Object.keys(replaceHost).forEach(key => {
            if (replacedUrl.includes(key)) {
                replacedUrl = replacedUrl.replace(key, replaceHost[key as keyof typeof replaceHost]);
            }
        });

        return replacedUrl;
    } else {
        return url;
    }
};
